import { InjectionToken } from '@angular/core';

/**
 * Base URL for gatewaymanager. Apps provide it from their environment file (e.g.
 * `https://api.dev.wheere.tech/gatewaymanager`). Mirrors the BASE_PATH token pattern of the
 * generated `@wheere/api-gateway` client so this lib can swap between hand-written calls and
 * the generated client without consumer changes.
 */
export const GATEWAYMANAGER_BASE_PATH = new InjectionToken<string>('GATEWAYMANAGER_BASE_PATH');
